import { LoginContext } from "./Context/LoginContext";
import {useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthToma = () => {
    const NavigateAuth = useNavigate();
    const { validador,setvalidador } = useContext(LoginContext);
    const CheckAuth = () =>{
        if (validador === 3) {
        
        }

        else {
        NavigateAuth("/");
        }
    }
    useEffect(() => {
        CheckAuth();
      }, []);
};

export default AuthToma;